import React from 'react';
import { Label } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { CommercialPriceVectorV106 } from './PriceOfferSelectorV106';
import './commercial.css';

export default function SourceQuotesV106({ quotes = [] }) {
  const { i18n } = useTranslation();
  const zh = i18n?.language?.startsWith('zh');
  const items = Array.isArray(quotes) ? quotes.filter((quote) => quote?.pricing_mode === 'reference' && quote.billable === false) : [];
  const asOf = (value) => {
    if (!value) return null;
    const date = new Date(typeof value === 'number' ? value * 1000 : value);
    return Number.isNaN(date.getTime()) ? null : date;
  };
  return (
    <div className='commercial-source-quotes-v106' aria-label={zh ? 'Source 参考报价' : 'Source reference quotes'}>
      <h4>{zh ? 'Source 参考报价' : 'Source reference quotes'}</h4>
      {!items.length ? <div className='commercial-source-empty-v106' role='status'>{zh ? '暂无报价' : 'No quotes'}</div> :
        <ul>{items.map((quote) => {
          const date = asOf(quote.price_as_of);
          const parent = items.find((item) => item.id === quote.parent_id);
          const container = quote.kind === 'openlux' || items.some((item) => item.parent_id === quote.id);
          return <li key={quote.id}>
            <div className='commercial-source-quote-heading-v106'>
              <strong>{quote.name}</strong>
              {quote.provider_name && <span>{quote.provider_name}</span>}
              {parent && parent.name !== quote.provider_name && <span>{parent.name}</span>}
              {!container && quote.effective_multiplier != null && <Label basic>x{quote.effective_multiplier}</Label>}
              <Label basic>{zh ? '参考' : 'Reference'}</Label>
              {container ? <Label basic>{zh ? '容器' : 'Container'}</Label> : quote.price_is_estimate && <Label basic>{zh ? '估算' : 'Estimate'}</Label>}
            </div>
            {Array.isArray(quote.resolutions) && quote.resolutions.length > 0 && <div className='commercial-source-quote-resolutions-v106'>{quote.resolutions.join(' / ')}</div>}
            {!container && (quote.customer_prices?.length ? <CommercialPriceVectorV106 offer={{ customer_prices: quote.customer_prices }} /> :
              <div className='commercial-source-empty-v106'>{zh ? '价格缺失' : 'Price unavailable'}</div>)}
            {date && <div className='commercial-source-asof-v106'>{zh ? '截至' : 'As of'} <time dateTime={date.toISOString()}>{date.toLocaleString(zh ? 'zh-CN' : 'en-US')}</time></div>}
          </li>;
        })}</ul>}
    </div>
  );
}
